<!-- filepath: d:\programming\vuejs-components\Vc Website Components\src\components\VcTooltip.vue -->
<template>
  <span ref="triggerRef" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
    <slot></slot>
  </span>
  
  <!-- Teleport tooltip to body to avoid parent constraints -->
  <teleport to="body">
    <div v-if="isVisible" 
         ref="tooltipRef"
         class="vc-tooltip"
         :class="[`vc-tooltip-${placement}`]"
         :style="tooltipStyle"
         role="tooltip">
      <div class="vc-tooltip-inner">
        <div v-if="title" class="vc-tooltip-title">{{ title }}</div>
        <div class="vc-tooltip-content">{{ content }}</div>
      </div>
      <div class="vc-tooltip-arrow" :style="arrowStyle"></div>
    </div>
  </teleport>
</template>

<script>
export default {
  name: 'VcTooltip',
  props: {
    title: String,
    content: {
      type: String,
      required: true
    },
    placement: {
      type: String,
      default: 'top',
      validator: (value) => ['top', 'bottom', 'left', 'right'].includes(value)
    },
    trigger: {
      type: String,
      default: 'hover',
      validator: (value) => ['hover', 'click'].includes(value)
    }
  },
  data() {
    return {
      isVisible: false,
      tooltipStyle: {},
      arrowStyle: {}
    }
  },
  methods: {
    handleMouseEnter() {
      if (this.trigger === 'hover') {
        this.show();
      }
    },
    handleMouseLeave() {
      if (this.trigger === 'hover') {
        this.hide();
      }
    },
    show() {
      this.isVisible = true;
      this.$nextTick(() => {
        this.updatePosition();
      });
    },
    hide() {
      this.isVisible = false;
    },
    updatePosition() {
      if (!this.$refs.triggerRef || !this.$refs.tooltipRef) return;
      
      const trigger = this.$refs.triggerRef;
      const tooltip = this.$refs.tooltipRef;
      
      const triggerRect = trigger.getBoundingClientRect();
      const tooltipRect = tooltip.getBoundingClientRect();
      
      let top = 0;
      let left = 0;
      
      switch (this.placement) {
        case 'top':
          top = triggerRect.top - tooltipRect.height - 8;
          left = triggerRect.left + (triggerRect.width - tooltipRect.width) / 2;
          break;
        case 'bottom':
          top = triggerRect.bottom + 8;
          left = triggerRect.left + (triggerRect.width - tooltipRect.width) / 2;
          break;
        case 'left':
          top = triggerRect.top + (triggerRect.height - tooltipRect.height) / 2;
          left = triggerRect.left - tooltipRect.width - 8;
          break;
        case 'right':
          top = triggerRect.top + (triggerRect.height - tooltipRect.height) / 2;
          left = triggerRect.right + 8;
          break;
      }
      
      // Adjust position to keep tooltip within viewport
      const padding = 10;
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      
      if (left < padding) left = padding;
      if (left + tooltipRect.width > viewportWidth - padding) {
        left = viewportWidth - tooltipRect.width - padding;
      }
      
      if (top < padding) top = padding;
      if (top + tooltipRect.height > viewportHeight - padding) {
        top = viewportHeight - tooltipRect.height - padding;
      }
      
      this.tooltipStyle = {
        top: `${top}px`,
        left: `${left}px`
      };
    }
  }
}
</script>

<style scoped>
.vc-tooltip {
  position: fixed; /* Use fixed positioning */
  z-index: 9999;
  pointer-events: none;
  max-width: 200px;
  /* Add any additional styling needed */
}

.vc-tooltip-inner {
  background-color: #fffcfc;
  padding: 0.5rem;
  /*color: #fff;
  padding: 5px 10px;
  border-radius: 4px;
  /* Add any additional styling needed */
}

.vc-tooltip-title {
  font-weight: bold;
  margin-bottom: 5px;
  /* Add any additional styling needed */
}

.vc-tooltip-content {
  /* Add any additional styling needed */
}

.vc-tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  /* Add any additional styling needed */
}

/* Positioning for arrow based on placement */
.vc-tooltip-top .vc-tooltip-arrow {
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px 5px 0 5px;
  /*border-color: #333 transparent transparent transparent;*/
    border-color: transparent transparent #333 transparent;
}

.vc-tooltip-bottom .vc-tooltip-arrow {
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 0 5px 5px 5px;

  border-color: #333 transparent transparent transparent;
}

.vc-tooltip-left .vc-tooltip-arrow {
  top: 50%;
  right: 100%;
  margin-top: -5px;
  border-width: 5px 5px 5px 0;
  border-color: transparent transparent transparent #333;
}

.vc-tooltip-right .vc-tooltip-arrow {
  top: 50%;
  left: 100%;
  margin-top: -5px;
  border-width: 5px 0 5px 5px;
  border-color: transparent #333 transparent transparent;
}
</style>